"use strict";

(function ($) {
  $.fn.toggleNav = function () {
    var that = this,
        panel = $('.js-panel'),
        main = $('.js-main');
    that.on('click', function () {
      panel.toggleClass('hidden');
      main.toggleClass('hidden-nav');
      $(this).toggleClass('hidden-nav');
    });
  };
})(jQuery);

$(function () {
  if ($('.js-toggle-nav').length) {
    $('.js-toggle-nav').toggleNav();
  }
});